import styled from "styled-components";

import { layout } from "styled-system";

const Svg = styled.svg`
  ${layout}
`;

export default Svg;
